import styled from 'styled-components'
import colors from 'configuration/colors'
import CheckmarkIcon from 'static/images/Skills/checkmark.svg'
import _AssessmentEmpty from './assets/asset_artifact_empty.svg'
import _AssessmentComplete from './assets/asset_artifact_complete.svg'
import _ApprovedFeedback from './assets/approved_feedback.svg'
import _AwaitingFeedback from './assets/awaiting_feedback.svg'
import _KeepWorking from './assets/keep_working.svg'
import _ApprovedFeedbackActivityCourse from './assets/approved_feedback_activity_course.svg'
import _AwaitingFeedbackActivityCourse from './assets/awaiting_feedback_activity_course.svg'
import _KeepWorkingActivityCourse from './assets/keep_working_activity_course.svg'
import DeleteBtn from 'static/images/icons/btn_close_default.svg'
import DeleteBtnHovered from 'static/images/icons/btn_close_hover.svg'
import FlexAlignCenter from '../../styled/FlexAlignCenter'

const CompletedOverlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 32px;
  width: 32px;
  background: rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  border-radius: ${props => (!props.isActivityCourse ? '50%' : '4px')};
  z-index: 1;
  margin-top: -4px;
`

export const ActiveDarkOverlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 32px;
  width: 32px;
  background: rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  border-radius: ${props => (!props.isActivityCourse ? '50%' : '4px')};
  z-index: 1;
  margin-top: -4px;
`

export const ActiveLightOverlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 32px;
  width: 32px;
  background: rgba(256, 256, 256, 0.7);
  transform: translate(-50%, -50%);
  border-radius: ${props => (!props.isActivityCourse ? '50%' : '4px')};
  z-index: 1;
  margin-top: -4px;
`

const Checkmark = styled.img.attrs({
  src: CheckmarkIcon
})`
  position: absolute;
  left: 50%;
  top: 42%;
  height: 10px;
  width: 13px;
  transform: translate(-50%, -50%);
  z-index: 2;
`

const CoreChoiceMarker = styled.div`
  border: 1px white solid;
  font-size: 8px;
  color: white;
  text-transform: uppercase;
  display: inline-block;
  padding: 3px;
`

const ProgressDiamond = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 17px;
  width: 17px;
  font-size: 9px;
  color: ${props => (props.hasProgress ? colors.white : colors.dove)};
  background: ${props => (props.hasProgress ? colors.cobalt : 'transparent')};
  border: ${props =>
    !props.hasProgress ? `1px solid ${colors.rock}` : 'none'};
  transform: rotate(-45deg);
  border-radius: 1px;
`

const AssessmentEmpty = styled.div`
  background: url(${_AssessmentEmpty}) no-repeat;
  color: ${colors.dove};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 24px;
  font-size: 9px;
  background-size: contain;
`

const AssessmentComplete = styled.div`
  background: url(${_AssessmentComplete}) no-repeat;
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 24px;
  font-size: 9px;
  background-size: contain;
`

const ApprovedIcon = styled.img.attrs(({ isActivityCourse }) => ({
  src: !isActivityCourse ? _ApprovedFeedback : _ApprovedFeedbackActivityCourse
}))`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 8px;
  height: 12px;
  width: 18px;
  z-index: 2;
`

const KeepWorkingIcon = styled.img.attrs(({ isActivityCourse }) => ({
  src: !isActivityCourse ? _KeepWorking : _KeepWorkingActivityCourse
}))`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 8px;
  height: 12px;
  width: 18px;
  z-index: 2;
`

const CheckinIcon = styled.img.attrs(({ isActivityCourse }) => ({
  src: !isActivityCourse ? _AwaitingFeedback : _AwaitingFeedbackActivityCourse
}))`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 8px;
  height: 12px;
  width: 18px;
  z-index: 2;
`

const TargetDateText = styled.p`
  color: #999999;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 21px;
  margin: 0;
  padding-left: 5px;
`
TargetDateText.displayName = 'TargetDateText'

const TargetDateDelete = styled.div`
  display: none;
  background: url(${DeleteBtn}) no-repeat;
  margin-right: 5px;
  width: 11px;
  height: 11px;
  &:hover {
    background: url(${DeleteBtnHovered}) no-repeat;
  }
`

const TargetDateBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  cursor: pointer;
  margin: 5px;
  padding: 3px;
  height: 30px;
  &:hover {
    background-color: #ebebeb;
    border-radius: 3px;
    ${TargetDateDelete} {
      display: block;
    }
  }
`

const ExpandedItemWrapper = styled(FlexAlignCenter)`
  justify-content: center;
  height: 40px;
`

export const HasNotification = styled.div`
  position: absolute;
  background-color: ${colors.notificationRed};
  top: -1px;
  right: -4px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  z-index: 4;
  border: 1px solid rgba(255, 255, 255, 1);
  background-clip: content-box;
`

const EmptyBlock = styled.div`
  width: 15px;
  height: 15px;
`

const QuestItem = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
`
const Progress = styled.div`
  position: absolute;
  top: -3px;
  left: -3px;
  width: 38px;
  height: 38px;
`

const ProgressLine = styled.div`
  position: absolute;
  bottom: 4px;
  background: ${colors.jade};
  width: 26px;
  height: 2px;
  margin: -3px 3px 0;
`

const DashboardWrapper = styled.div`
  display: inline-flex;
  position: relative;
  cursor: pointer;
  margin: 4px 2px 0 2px;
  padding-bottom: 4px;

  .icon-wrapper {
    width: 40px !important;
    height: 40px !important;

    .icon {
      width: 100% !important;
      height: 100% !important;
      opacity: 1;
    }
  }
  
  ${Progress} {
      width: 46px !important;
      height: 46px !important;
    }

    ${ProgressLine} {
      bottom: 0;
      width: 33px;
    }

    ${CompletedOverlay} {
      width: 40px !important;
      height: 40px !important;
      margin-top: -2px;
    }

    ${ActiveLightOverlay} {
      width: 40px !important;
      height: 40px !important;
      margin-top: -2px;
    }

    ${ActiveDarkOverlay} {
      width: 40px !important;
      height: 40px !important;
      margin-top: -2px;
    }

    ${Checkmark} {
      top: 45%;
      height: 12px;
      width: 16px;
    }
    ${CheckinIcon} {
      bottom: 4px;
      height: 14px;
      width: 21px;
    }
    ${ApprovedIcon} {
      bottom: 4px;
      height: 14px;
      width: 21px;
    }
    ${KeepWorkingIcon} {
      bottom: 4px;
      height: 14px;
      width: 21px;
    }

  .icon-wrapper {
    border: 1px solid #cccccc;
    border-radius: ${props => (props.isActivityCourse ? '4px' : '50%')};

    .icon {
      border: none !important;
      border-radius: ${props =>
  props.isActivityCourse ? '4px' : '50%'} !important;
      opacity: ${props =>
  props.noProgress && !props.isComplete && !props.isMentorViewingOwn
    ? '.15'
    : '1'};
    }
  }
`

const QuestIconClassWrapper = styled.div`
  display: inline-flex;
  position: relative;
  cursor: pointer;
  margin: 8px 6px 0 6px;
  padding-bottom: 8px;

  &:hover {
    margin: 4px 2px 0 2px;
    padding-bottom: 4px;

    .icon-wrapper {
      width: 40px !important;
      height: 40px !important;

      .icon {
        width: 100% !important;
        height: 100% !important;
        opacity: 1;
      }
    }

    ${Progress} {
      width: 46px !important;
      height: 46px !important;
    }

    ${ProgressLine} {
      bottom: 0;
      width: 33px;
    }

    ${CompletedOverlay} {
      width: 40px !important;
      height: 40px !important;
      margin-top: -2px;
    }

    ${ActiveLightOverlay} {
      width: 40px !important;
      height: 40px !important;
      margin-top: -2px;
    }

    ${ActiveDarkOverlay} {
      width: 40px !important;
      height: 40px !important;
      margin-top: -2px;
    }

    ${Checkmark} {
      top: 45%;
      height: 12px;
      width: 16px;
    }
    ${CheckinIcon} {
      bottom: 4px;
      height: 14px;
      width: 21px;
    }
    ${ApprovedIcon} {
      bottom: 4px;
      height: 14px;
      width: 21px;
    }
    ${KeepWorkingIcon} {
      bottom: 4px;
      height: 14px;
      width: 21px;
    }
  }

  .icon-wrapper {
    border: 1px solid #cccccc;
    border-radius: ${props => (props.isActivityCourse ? '4px' : '50%')};

    .icon {
      width: 30px !important;
      height: 30px !important;
      border: none !important;
      border-radius: ${props =>
  props.isActivityCourse ? '4px' : '50%'} !important;
      opacity: ${props =>
  props.noProgress && !props.isComplete && !props.isMentorViewingOwn
    ? '.15'
    : '1'};
    }
  }
`

export {
  CompletedOverlay,
  Checkmark,
  CoreChoiceMarker,
  ProgressDiamond,
  AssessmentComplete,
  AssessmentEmpty,
  ApprovedIcon,
  KeepWorkingIcon,
  CheckinIcon,
  TargetDateBlock,
  TargetDateText,
  TargetDateDelete,
  ExpandedItemWrapper,
  QuestItem,
  EmptyBlock,
  QuestIconClassWrapper,
  DashboardWrapper,
  Progress,
  ProgressLine,
}
